/**
 * @desc 需求初审-附件更新
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductConfirmFileRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/updateFiles`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
